import React from "react";
import { DateTime } from "luxon";
import css from "./DatePickerInput.module.scss";

export interface DatePickerInputProps {
  isActive: boolean;
  label: string;
  value: string | null;
  onClick: () => void;
}

const DatePickerInput: React.FC<DatePickerInputProps> = ({ isActive, label, value, onClick }) => {
  const dateString = value ? DateTime.fromISO(value).toFormat("dd/MM/yyyy") : "dd/mm/yyyy";

  const attrs = {
    container: {
      className: css.container,
    },
    label: {
      className: css.label,
    },
    input: {
      type: "button" as const,
      disabled: isActive,
      className: css.input,
      onClick,
    },
  };

  return (
    <div {...attrs.container}>
      <span {...attrs.label}>{label}</span>
      <button {...attrs.input}>
        <span>{dateString}</span>
      </button>
    </div>
  );
};

export default DatePickerInput;
